
import { mapPersonalInfoType, PersonalInfoType } from "./PersonalInfoType";
import { mapUserRoleInfoType, UserRoleInfoType } from "./UserRoleInfoType";

export interface AttendanceHomeType {
  personal_info_id?: number;
  attendance_date?: string;
  site_address?: string;
  full_address?: string;
  project_id?: number;
  status?: string;
  payed?: number;
  daily_hours?: number;
  daily_wage?: number;
  personalInfo?: PersonalInfoType | null;
  userRoleInfo?: UserRoleInfoType | null;
}

// to single object maping
export const mapAttendanceHomeType = (data: any): AttendanceHomeType => {
  if (!data) {
    throw new Error("Invalid Data");
  }
  const res: AttendanceHomeType = {
      personal_info_id: data.personal_info_id,
    attendance_date: data.attendance_date,
    site_address: data.site_address,
    full_address: data.full_address,
    project_id: data.project_id,
    status: data.status,
    payed: data.payed,
    daily_hours: data.daily_hours,
    daily_wage: data.daily_wage,
    personalInfo:
      data.personalInfo !== null
        ? mapPersonalInfoType(data.personalInfo)
        : null,
    userRoleInfo:
      data.userRoleInfo !== null
        ? mapUserRoleInfoType(data.userRoleInfo)
        : null,
  };
  return res;
};
 
// maping list objects
export const mapAttendanceHomeTypes = (data: any[]): AttendanceHomeType[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }
  return data.map(mapAttendanceHomeType);
};
